import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent {
  features = [
    {
      icon: 'pi-shield',
      title: 'Single Sign-On',
      desc: 'One identity across all SupplyValid platforms — CAPITAL, SOVRN, and SVN.'
    },
    {
      icon: 'pi-users',
      title: 'Role-Based Access',
      desc: 'Granular permissions per client and region. Full control over who sees what.'
    },
    {
      icon: 'pi-globe',
      title: 'Multi-Region Support',
      desc: 'India and US deployments managed from a single unified console.'
    },
    {
      icon: 'pi-lock',
      title: 'Secure by Design',
      desc: 'Token-based auth, OTP verification, and forced password policies built in.'
    },
    {
      icon: 'pi-bolt',
      title: 'Fast Onboarding',
      desc: 'Create, activate, and assign roles to users in seconds — not hours.'
    },
    {
      icon: 'pi-chart-bar',
      title: 'Audit & Logs',
      desc: 'Full event logging for every login, role change, and admin action.'
    }
  ];
}
